// Tab scoreboard overlay.

import { div, setText } from "./dom";
import { modeLabel } from "./format";
import { ScoreLayout } from "./scoretable";
import type { ScoreboardView } from "./types";

export class Scoreboard {
  readonly root = div("hud-sb");
  private readonly titleEl = div("hud-sb__title");
  private readonly modeEl = div("hud-sb__mode");
  private readonly layout = new ScoreLayout();
  private view: ScoreboardView | null = null;
  private dirty = false;
  private visible = false;

  constructor() {
    const zoom = div("hud-zoom");
    const panel = div("hud-sb__panel");
    const head = div("hud-sb__head");
    head.append(this.titleEl, this.modeEl);
    panel.append(head, this.layout.root);
    zoom.append(panel);
    this.root.append(zoom);
    this.root.hidden = true;
  }

  /** Store the latest data. Rendered immediately only while the scoreboard is visible. */
  set(view: ScoreboardView): void {
    this.view = view;
    this.dirty = true;
    if (this.visible) this.flush();
  }

  show(v: boolean): void {
    if (v === this.visible) return;
    this.visible = v;
    this.root.hidden = !v;
    if (v && this.dirty) this.flush();
  }

  private flush(): void {
    const view = this.view;
    if (!view) return;
    this.dirty = false;
    setText(this.titleEl, view.title);
    setText(this.modeEl, modeLabel(view.mode));
    this.layout.render(view.rows, view.mode !== "ffa", view.teamScores, view.mode === "koth" || view.mode === "defusal");
  }
}
